/*
 * size-stack.js  (store-neutral port of rr-size-stack.js; first installed on Andrea & Avery, UK)
 * Stacks Swatch King shoe size buttons whose label is exactly
 *   "<MARKET> <n|range> · EU <n|range>"   MARKET = AU | UK | US
 *   e.g. "UK 4 · EU 36", "AU 6–6.5 · EU 35–36"; the older "UK 4 / EU 36" form is also accepted
 * into two lines: big "UK 4" over small grey "EU 36".
 * Every other label (clothing sizes, colours, "One Size", plain numbers) is left untouched.
 *
 * Swatch King re-renders buttons with innerHTML on selection / variant change / quick view,
 * so a debounced MutationObserver re-applies. Idempotent: a span that already holds .sz-mkt is skipped.
 * Inserted spans carry swatch-inside="true": Swatch King's click handler walks up from the
 * click target while that attribute is present, so clicks on the new spans still select the size.
 */
(function () {
  'use strict';
  if (window.__sizeStack) return;
  window.__sizeStack = true;

  var NUM = '\\d+(?:\\.\\d+)?(?:\\s*[-\\u2013]\\s*\\d+(?:\\.\\d+)?)?';
  var RE = new RegExp('^(AU|UK|US)\\s+(' + NUM + ')\\s*[\\u00B7/]\\s*EU\\s+(' + NUM + ')$');
  var SPAN_SEL = '.swatch-button .swatch-button-title-text > span';

  function el(cls, text, hidden) {
    var s = document.createElement('span');
    s.className = cls;
    s.setAttribute('swatch-inside', 'true');
    if (hidden) s.setAttribute('aria-hidden', 'true');
    s.textContent = text;
    return s;
  }

  function stackSpan(span) {
    // only a span that holds a single plain text node
    if (span.childNodes.length !== 1 || span.firstChild.nodeType !== 3) return;
    var full = span.textContent;
    var m = RE.exec(full.trim());
    if (!m) return;
    var btn = span.closest('.swatch-button');
    if (!btn) return;
    var frag = document.createDocumentFragment();
    frag.appendChild(el('sz-mkt', m[1] + ' ' + m[2], true));
    frag.appendChild(el('sz-eu', 'EU ' + m[3], true));
    frag.appendChild(el('sz-sr', full.trim(), false)); // screen readers read the full label
    span.textContent = '';
    span.appendChild(frag);
    btn.classList.add('sz-stack');
  }

  function scan() {
    var spans = document.querySelectorAll(SPAN_SEL);
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].querySelector('.sz-mkt')) stackSpan(spans[i]);
    }
    // a button Swatch King re-used with a non-shoe label loses the stack class
    var stacked = document.querySelectorAll('.swatch-button.sz-stack');
    for (var j = 0; j < stacked.length; j++) {
      if (!stacked[j].querySelector('.sz-mkt')) stacked[j].classList.remove('sz-stack');
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; scan(); }, 30);
  }

  function relevant(muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      var n = t.nodeType === 1 ? t : t.parentNode;
      if (!n) continue;
      // ignore our own writes inside a stacked span
      if (n.closest && n.closest('.sz-mkt, .sz-eu, .sz-sr')) continue;
      return true;
    }
    return false;
  }

  function start() {
    scan();
    new MutationObserver(function (muts) { if (relevant(muts)) schedule(); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
